import { GAME_WIDTH, GAME_HEIGHT, SCENE } from '../../config.js';
import { makeVisitScene } from './VisitSceneBase.js';
import { ROOM_PERSPECTIVE } from '../roomPerspective.mjs';
import { homeArrival } from '../homeLayout.mjs';

// Host's kitchen — same as the owner KitchenScene: return to Home via the bottom edge.
export const VisitKitchenScene = makeVisitScene({
  key: SCENE.VISIT_KITCHEN,
  roomScene: 'KitchenScene',
  areaKey: 'kitchen',
  bgKey: () => 'bg_kitchen',
  spawn: { x: GAME_WIDTH / 2, y: GAME_HEIGHT - 240 },
  perspective: ROOM_PERSPECTIVE.kitchen,
  exits: [
    { side: 'bottom', toScene: SCENE.VISIT_HOME, label: '{arrow_down} Dom', data: homeArrival('kuchnia') },
  ],
});
